export enum TileFlag {
  CF_NONE,
  CF_PUSHUPDOWN,
  CF_PUSH4WAY,
  CF_WHISTLE,
  CF_CANDLE1,
  CF_ARROW,
  CF_BOMB,
  CF_FAIRY,
  CF_RAFT,
  CF_ARMOSSECRET,
  CF_ARMOSITEM,
  CF_SBOMB,
  CF_RAFTBRANCH,
  CF_DIVEITEM,
  CF_ZELDA,
  CF_SECRETS01,
  CF_SECRETS02,
  CF_SECRETS03,
  CF_SECRETS04,
  CF_SECRETS05,
  CF_SECRETS06,
  CF_SECRETS07,
  CF_SECRETS08,
  CF_SECRETS09,
  CF_SECRETS10,
  CF_SECRETS11,
  CF_SECRETS12,
  CF_SECRETS13,
  CF_SECRETS14,
  CF_SECRETS15,
  CF_SECRETS16,
  CF_TRAPH,
  CF_TRAPV,
  CF_TRAP4WAY,
  CF_TRAPLR,
  CF_TRAPUD,
  CF_ENEMY0,
  CF_ENEMY1,
  CF_ENEMY2,
  CF_ENEMY3,
  CF_ENEMY4,
  CF_ENEMY5,
  CF_ENEMY6,
  CF_ENEMY7,
  CF_ENEMY8,
  CF_ENEMY9,
  CF_PUSHLR,
  CF_PUSHUP,
  CF_PUSHDOWN,
  CF_PUSHLEFT,
  CF_PUSHRIGHT,
  CF_PUSHUPDOWNNS,
  CF_PUSHLEFTRIGHTNS,
  CF_PUSH4WAYNS,
  CF_PUSHUPNS,
  CF_PUSHDOWNNS,
  CF_PUSHLEFTNS,
  CF_PUSHRIGHTNS,
  CF_PUSHUPDOWNINS,
  CF_PUSHLEFTRIGHTINS,
  CF_PUSH4WAYINS,
  CF_PUSHUPINS,
  CF_PUSHDOWNINS,
  CF_PUSHLEFTINS,
  CF_PUSHRIGHTINS,
  CF_BLOCKTRIGGER,
  CF_NOBLOCKS,
  CF_BRANG1,
  CF_BRANG2,
  CF_BRANG3,
  CF_ARROW2,
  CF_ARROW3,
  CF_CANDLE2,
  CF_WANDFIRE,
  CF_DINSFIRE,
  CF_WANDMAGIC,
  CF_REFMAGIC,
  CF_REFFIREBALL,
  CF_SWORD1,
  CF_SWORD2,
  CF_SWORD3,
  CF_SWORD4,
  CF_SWORD1BEAM,
  CF_SWORD2BEAM,
  CF_SWORD3BEAM,
  CF_SWORD4BEAM,
  CF_HOOKSHOT,
  CF_WAND,
  CF_HAMMER,
  CF_STRIKE,
  CF_BLOCKHOLE,
  CF_MAGICFAIRY,
  CF_ALLFAIRY,
  CF_SINGLE,
  CF_SINGLE16,
  CF_NOENEMY,
  CF_NOGROUNDENEMY,
  CF_SCRIPT1,
  CF_SCRIPT2,
  CF_SCRIPT3,
  CF_SCRIPT4,
  CF_SCRIPT5,
};

export enum SecretCombo {
  SECCMB_BCANDLE,
  SECCMB_ARROW,
  SECCMB_BOMB,
  SECCMB_STAIRS,
  SECCMB_SECRET01,
  SECCMB_SECRET02,
  SECCMB_SECRET03,
  SECCMB_SECRET04,
  SECCMB_SECRET05,
  SECCMB_SECRET06,
  SECCMB_SECRET07,
  SECCMB_SECRET08,
  SECCMB_SECRET09,
  SECCMB_SECRET10,
  SECCMB_SECRET11,
  SECCMB_SECRET12,
  SECCMB_SECRET13,
  SECCMB_SECRET14,
  SECCMB_SECRET15,
  SECCMB_SECRET16,
  SECCMB_RCANDLE,
  SECCMB_WANDFIRE,
  SECCMB_DINSFIRE,
  SECCMB_SARROW,
  SECCMB_GARROW,
  SECCMB_SBOMB,
  SECCMB_BRANG,
  SECCMB_MBRANG,
  SECCMB_FBRANG,
  SECCMB_WANDMAGIC,
  SECCMB_REFMAGIC,
  SECCMB_REFFIREBALL,
  SECCMB_SWORD,
  SECCMB_WSWORD,
  SECCMB_MSWORD,
  SECCMB_XSWORD,
  SECCMB_SWORDBEAM,
  SECCMB_WSWORDBEAM,
  SECCMB_MSWORDBEAM,
  SECCMB_XSWORDBEAM,
  SECCMB_HOOKSHOT,
  SECCMB_WAND,
  SECCMB_HAMMER,
  SECCMB_STRIKE,
  SECCMB_SECRETSNEXT,
};

export function getPushData(flag: TileFlag) {
  const isPushFlag = [
    TileFlag.CF_PUSHUPDOWN,
    TileFlag.CF_PUSH4WAY,
    TileFlag.CF_PUSHLR,
    TileFlag.CF_PUSHUP,
    TileFlag.CF_PUSHDOWN,
    TileFlag.CF_PUSHLEFT,
    TileFlag.CF_PUSHRIGHT,
    TileFlag.CF_PUSHUPDOWNNS,
    TileFlag.CF_PUSHLEFTRIGHTNS,
    TileFlag.CF_PUSH4WAYNS,
    TileFlag.CF_PUSHUPNS,
    TileFlag.CF_PUSHDOWNNS,
    TileFlag.CF_PUSHLEFTNS,
    TileFlag.CF_PUSHRIGHTNS,
    TileFlag.CF_PUSHUPDOWNINS,
    TileFlag.CF_PUSHLEFTRIGHTINS,
    TileFlag.CF_PUSH4WAYINS,
    TileFlag.CF_PUSHUPINS,
    TileFlag.CF_PUSHDOWNINS,
    TileFlag.CF_PUSHLEFTINS,
    TileFlag.CF_PUSHRIGHTINS,
  ].includes(flag);
  if (!isPushFlag) return;

  const directions = [];
  if ([TileFlag.CF_PUSHUPDOWN, TileFlag.CF_PUSHUP, TileFlag.CF_PUSH4WAY, TileFlag.CF_PUSHUPINS, TileFlag.CF_PUSHUPDOWNINS, TileFlag.CF_PUSHUPNS, TileFlag.CF_PUSH4WAYINS].includes(flag)) {
    directions.push('up');
  }
  if ([TileFlag.CF_PUSHUPDOWN, TileFlag.CF_PUSHDOWN, TileFlag.CF_PUSH4WAY, TileFlag.CF_PUSHDOWNINS, TileFlag.CF_PUSHUPDOWNINS, TileFlag.CF_PUSHDOWNNS, TileFlag.CF_PUSH4WAYINS].includes(flag)) {
    directions.push('down');
  }
  if ([TileFlag.CF_PUSHLR, TileFlag.CF_PUSHLEFT, TileFlag.CF_PUSH4WAY, TileFlag.CF_PUSHLEFTINS, TileFlag.CF_PUSHLEFTRIGHTINS, TileFlag.CF_PUSHLEFTNS, TileFlag.CF_PUSH4WAYINS].includes(flag)) {
    directions.push('left');
  }
  if ([TileFlag.CF_PUSHLR, TileFlag.CF_PUSHRIGHT, TileFlag.CF_PUSH4WAY, TileFlag.CF_PUSHRIGHTINS, TileFlag.CF_PUSHLEFTRIGHTINS, TileFlag.CF_PUSHRIGHTNS, TileFlag.CF_PUSH4WAYINS].includes(flag)) {
    directions.push('right');
  }

  const triggerSecrets = [
    TileFlag.CF_PUSHUPDOWN,
    TileFlag.CF_PUSH4WAY,
    TileFlag.CF_PUSHLR,
    TileFlag.CF_PUSHUP,
    TileFlag.CF_PUSHDOWN,
    TileFlag.CF_PUSHLEFT,
    TileFlag.CF_PUSHRIGHT,
  ].includes(flag);

  const many = [
    TileFlag.CF_PUSHUPDOWNINS,
    TileFlag.CF_PUSHLEFTRIGHTINS,
    TileFlag.CF_PUSH4WAYINS,
    TileFlag.CF_PUSHUPINS,
    TileFlag.CF_PUSHDOWNINS,
    TileFlag.CF_PUSHLEFTINS,
    TileFlag.CF_PUSHRIGHTINS,
  ].includes(flag);

  return { directions, triggerSecrets, many };
}
